import React from 'react';
import OverviewTab from './overview-tab';
import PayoutsTab from './payouts-tab';
import { PlatformFinanceBody } from '../../platform-finance/platform-finance';
import AccountActivity from '../account-activity/account-activity';
import ConnectAccountsTable from '../components/ConnectAccountsTable';
const ADMIN_BODIES = {
  overview: <OverviewTab />,
  revenue: <PlatformFinanceBody />,
  payouts: <PayoutsTab />,
  connect: <ConnectAccountsTable />,
  ledger: <AccountActivity embedded />,
};
export default ADMIN_BODIES;
